import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';
import * as models from '../../models';
import * as actions from './actions';
import * as constants from './constants';

export interface DashboardStateShape {
    adjusterDashboard: models.AdjusterDashboard; 
    adminDashbard: models.AdminDashboard; 
    isAdjusterDashboardLoading: boolean; 
    isAdminDashboardLoading: boolean; 
    isInvoicesDownloading: boolean; 
    isPayrollDashboardLoading: boolean; 
    monthlyClaimsActivity: models.MonthlyClaimActivityResponse; 
    payrollDashbaord: models.PayrollDashboard; 
 }

export const dashboardDefaultState: DashboardStateShape = {
    adjusterDashboard: models.defaultAdjusterDashboard, 
    adminDashbard: models.defaultAdminDashboard, 
    isAdjusterDashboardLoading: false, 
    isAdminDashboardLoading: false, 
    isInvoicesDownloading: false,  
    isPayrollDashboardLoading: false, 
    monthlyClaimsActivity: models.defaultDashbardResponse, 
    payrollDashbaord: models.defaultPayrollDashboard, 
};

export interface State {    
    dashboards: DashboardStateShape;
}

export type Action = ActionType<typeof actions>;

export default combineReducers<State, Action>({
    dashboards: (state = dashboardDefaultState, action) => {
        switch (action.type) {   
            case constants.CLEAR_ADJUSTER_DASHBOARD: 
                return {
                    ...state, 
                    adjusterDashboard: models.defaultAdjusterDashboard, 
                }
            case constants.REQUEST_ADJUSTER_DASHBOARD: 
                return {
                    ...state,
                    isAdjusterDashboardLoading: true,
                }
            case constants.RECEIVE_ADJUSTER_DASHBOARD: 
                return {
                    ...state,
                    isAdjusterDashboardLoading: false, 
                    adjusterDashboard: action.payload.response,
                }
            case constants.RECEIVE_ADJUSTER_DASHBOARD_FAILURE: 
                return {
                    ...state,
                    isAdjusterDashboardLoading: false, 
                    adjusterDashboard: models.defaultAdjusterDashboard,
                }

            case constants.REQUEST_ADJUSTER_INVOICES: 
                return {
                    ...state,
                    isInvoicesDownloading: true, 
                }
            case constants.RECEIVE_ADJUSTER_INVOICES: 
            case constants.RECEIVE_ADJUSTER_INVOICES_FAILURE: 
                return {
                    ...state, 
                    isInvoicesDownloading: false, 
                }

            case constants.REQUEST_ADMIN_DASHBOARD: 
                return {
                    ...state, 
                    isAdminDashboardLoading: true, 
                }
            case constants.RECEIVE_ADMIN_DASHBOARD: 
                return {
                    ...state, 
                    isAdminDashboardLoading: false, 
                    adminDashbard: action.payload.response, 
                }
            case constants.RECEIVE_ADMIN_DASHBOARD_FAILURE: 
                return {
                    ...state, 
                    isAdminDashboardLoading: false, 
                }
                
            case constants.REQUEST_MONTHLY_CLAIM_ACTIVITY: 
                return {
                    ...state,                    
                }
            case constants.RECEIVE_MONTHLY_CLAIM_ACTIVITY:
                return {
                    ...state, 
                    monthlyClaimsActivity: action.payload.response,
                }

            case constants.REQUEST_PAYROLL_DASHBOARD: 
                return {
                    ...state, 
                    isPayrollDashboardLoading: true, 
                }
            case constants.RECEIVE_PAYROLL_DASHBOARD: 
                return {
                    ...state, 
                    isPayrollDashboardLoading: false, 
                    payrollDashbaord: action.payload.response,
                }
            case constants.RECEIVE_PAYROLL_DASHBOARD_FAILURE: 
                return {
                    ...state, 
                    isPayrollDashboardLoading: false, 
                }

            default: 
                return state; 
        }
    }
});
